module.exports = __webpack_public_path__ + "static/media/Swatini.52a0d7df.png";